<div class="client-search-wrapper">
  <p-iftalabel>

    <p-autoComplete
      [(ngModel)]="query"
      [suggestions]="results()"
      [dropdown]="true"
      [appendTo]="'body'"
      (completeMethod)="searchClients($event)"
      (onSelect)="onClientSelect($event)"
      [autoHighlight]="true"
      [fluid]="true"
      [emptyMessage]="emptyMessage"
      inputId="clientSearch"
    >

      <ng-template let-item pTemplate="item">
        <bai-client-info
          [session]="item.value"
          [timestamp]="item.value.timestamp"
        />
      </ng-template>
      <ng-template pTemplate="empty">
<!--        <div>{{ emptyMessage }}</div>-->
      </ng-template>
      <ng-template pTemplate="footer">
        <div class="px-3 py-2 text-sm text-gray-500 flex items-center gap-2">
          <i
            *ngIf="loadingFromApi()"
            class="pi pi-spin pi-spinner text-gray-400"
          ></i>
          <span *ngIf="loadingFromApi()">Searching remote clients...</span>
          <span *ngIf="!loadingFromApi() && results().length === 0">No matches found</span>
        </div>
      </ng-template>
    </p-autoComplete>
    <label for="clientSearch">Search Clients</label>
  </p-iftalabel>
</div>
